import { render } from "./StudyTopicTypes.vue?vue&type=template&id=6a4c4e82"
import script from "./StudyTopicTypes.vue?vue&type=script&lang=js"
export * from "./StudyTopicTypes.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/StudyTopicTypes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a4c4e82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a4c4e82', __exports__)) {
    api.reload('6a4c4e82', __exports__)
  }
  
  module.hot.accept("./StudyTopicTypes.vue?vue&type=template&id=6a4c4e82", () => {
    api.rerender('6a4c4e82', render)
  })

}


export default __exports__